import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import RelectAndIntegrate1Image from "../../../Assets/Images/RelectAndIntegrate1Image.png";
import RelectAndIntegrateIcon from "../../../Assets/Images/RelectAndIntegrateIcon.png"

const RelectAndIntegrate1 = () => {

    Font.register({
        family: 'Lato',
        fonts: [
            { src: LatoRegular, fontWeight: 400 },
            { src: LatoBold, fontWeight: 700 }
        ]
    });


    const styles = StyleSheet.create({
        footer: {
            position: "absolute",
            bottom: "0px",
            borderTop: "1px solid #426B88",
            display: "flex",
            flexDirection: "row",
            width: "571px",
            gap: "30px"
        },
        pagewapper: {
            position: "relative",
            height: "100%"
        },
        footertitle: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            textTransform: "uppercase",
            marginTop: "10px"
        },
        description: {
            color: "#76A3BE",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "8px",
            lineHeight: "18px",
            width: "496px"

        },
        pagenumber: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            marginTop: "10px",
        },
        image: {
            width: "574px",
            height: "300px",

        },
        content : {
            width : "570px",
            height : "710px",
            display : "flex",
            flexDirection : "column",
        },
        imageContainer : {
            width: "574px",
            height: "300px",
        },
        contentDescription : {
            display : "flex",
            flexDirection : "column",
            alignItems : "center",
            marginTop : "70px",
            gap : "50px",
            justifyContent : "center"
        },
        icon : {
            width : "68px",
            height  :"68px"
        },
        text : {
            fontFamily : "Lato",
            fontWeight : 700,
            fontSize : "24px",
            lineHeight  :"30px",
            color : "#00577D"
        }
    });
    return (

        <View style={styles.pagewapper}>
            <View style={styles.content}>
                <View style={styles.imageContainer}>
                    <Image src={RelectAndIntegrate1Image} style={styles.image} />
                </View>
                <View style={styles.contentDescription}>
                    <Image src={RelectAndIntegrateIcon} style={styles.icon}/>
                    <Text style={styles.text}>REFLECT & INTEGRATE</Text>
                </View>
            </View>
            <View style={styles.footer}>
                <View>
                    <Text style={styles.footertitle}>SELF Report</Text>
                    <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                </View>
                <View style={styles.pagenumber}>
                    <Text>PAGE</Text>
                </View>

            </View>

        </View>

    )
}

export default RelectAndIntegrate1